var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlaebested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.62,7.67l3.055,0a.167.167,0,0,0,.171-.185A7.2,7.2,0,0,0,5.571,2.9a.178.178,0,0,0-.279.108l-.84,4.462A.17.17,0,0,0,4.62,7.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.709,10.05a1.54,1.54,0,0,1,2.2.006.712.712,0,0,0,1.092,0,1.539,1.539,0,0,1,2.2,0l.037.032.8-1.217a.364.364,0,0,0-.334-.553H2.346A.365.365,0,0,0,2,8.856Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,10.559a1.342,1.342,0,0,0-.907-.332,1.429,1.429,0,0,0-1.03.437.815.815,0,0,1-1.231,0,1.437,1.437,0,0,0-2.064,0,.819.819,0,0,1-.616.281.317.317,0,0,0,0,.633,1.428,1.428,0,0,0,1.032-.437.816.816,0,0,1,1.232,0,1.436,1.436,0,0,0,2.063,0A.818.818,0,0,1,7.1,10.86a.716.716,0,0,1,.507.19.317.317,0,1,0,.4-.491Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.459,9.05H11.215a.762.762,0,0,0-.476.167L8.088,11.336a.157.157,0,0,0,.1.28h5.273a.157.157,0,0,0,.158-.157V9.208A.158.158,0,0,0,13.459,9.05Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlaebested);
export default __webpack_public_path__ + "static/media/SLAEBESTED.3edee91a24149e7cb486589f4298c2d7.svg";
export { ForwardRef as ReactComponent };